import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® es para la depresión resistente al tratamiento?",
    answer:
      "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La depresión resistente al tratamiento suele definirse por la falta de respuesta a varios antidepresivos. La elegibilidad se confirma en una consulta.",
  },
];

export const esSaintForTrd = makeEsArticle({
  slug: "is-saint-for-treatment-resistant-depression",
  title: "¿SAINT® es para la depresión resistente al tratamiento?",
  description:
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos, una forma de depresión resistente al tratamiento.",
  h1: "¿SAINT® es para la depresión resistente al tratamiento?",
  breadcrumbLabel: "SAINT® para depresión resistente",
  shortAnswer:
    "SAINT® está autorizada por la FDA (510(k) K220177, septiembre de 2022) para el trastorno depresivo mayor en adultos que no han logrado una mejoría satisfactoria con antidepresivos en el episodio actual. La depresión resistente al tratamiento suele definirse como depresión que no ha respondido lo suficiente a varios antidepresivos. SAINT® es una de las opciones para adultos en esa situación. La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® está indicada para el trastorno depresivo mayor en adultos.",
    "Está indicada cuando los antidepresivos no han mejorado lo suficiente.",
    "La depresión resistente al tratamiento suele definirse por falta de respuesta a varios antidepresivos.",
    "SAINT® es una opción para adultos en esa situación.",
    "La elegibilidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "Depresión resistente al tratamiento",
      paragraphs: [
        "La depresión resistente al tratamiento suele definirse como depresión que no ha respondido lo suficiente a varios antidepresivos. SAINT® está indicada para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos, una de las formas de depresión resistente al tratamiento.",
        "SAINT® combina 50 sesiones en cinco días con orientación individualizada por fMRI y patrón theta burst. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "U.S. Food and Drug Administration. 510(k) Premarket Notification — Magnus Neuromodulation System with SAINT Technology (K220177, September 2022).",
      url: "https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
